export default "__VITE_ASSET__vvM6g9Mp__"